import { getEffectiveDayPlan, formatDayDate } from '../data/plan'
import { computeDayNutrition } from './mealOverrides'

function downloadFile(content, filename, mimeType) {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  URL.revokeObjectURL(url)
}

// A full, restore-capable snapshot of everything stored for this account.
export function exportFullBackup(profile, logs, inventory, templates) {
  const data = { exportedAt: new Date().toISOString(), profile, logs, inventory, templates }
  downloadFile(JSON.stringify(data, null, 2), `healthnest-backup-${new Date().toISOString().slice(0, 10)}.json`, 'application/json')
}

// One row per logged day - weight, steps, kcal/protein eaten, and
// completion counts - for opening in a spreadsheet.
export function exportDailySummaryCSV(logs, aiPlan) {
  const rows = Object.values(logs)
    .filter((log) => log.dayNumber)
    .sort((a, b) => a.dayNumber - b.dayNumber)
    .map((log) => {
      const plan = getEffectiveDayPlan(log.dayNumber, aiPlan)
      const { checkedKcal, checkedProtein } = computeDayNutrition(log.dayNumber, log, aiPlan)
      const exercisesDone = plan.exercises.filter((e) => log.exerciseChecks?.[e.name]).length
      const mealsDone = plan.meals.filter((m) => log.mealChecks?.[m.key]).length
      const suppsDone = plan.supplements.filter((s) => log.supplementChecks?.[s.key]).length
      return {
        day: log.dayNumber,
        date: formatDayDate(log.dayNumber),
        weightKg: log.weightKg ?? '',
        steps: log.steps ?? '',
        kcalEaten: checkedKcal,
        proteinEaten: checkedProtein,
        exercisesDone: `${exercisesDone}/${plan.exercises.length}`,
        mealsDone: `${mealsDone}/${plan.meals.length}`,
        supplementsDone: `${suppsDone}/${plan.supplements.length}`,
        notes: log.notes || '',
      }
    })

  const headers = ['day', 'date', 'weightKg', 'steps', 'kcalEaten', 'proteinEaten', 'exercisesDone', 'mealsDone', 'supplementsDone', 'notes']
  const csvLines = [
    headers.join(','),
    ...rows.map((r) => headers.map((h) => `"${String(r[h]).replace(/"/g, '""')}"`).join(',')),
  ]
  downloadFile(csvLines.join('\n'), `healthnest-daily-summary-${new Date().toISOString().slice(0, 10)}.csv`, 'text/csv')
}
